import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPaperclipSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      d="m20 11.114-8.024 7.591c-1.824 1.727-4.783 1.727-6.607 0-1.825-1.726-1.825-4.525 0-6.251l8.024-7.59c1.216-1.152 3.188-1.152 4.405 0a2.836 2.836 0 0 1 0 4.167l-7.71 7.293a1.62 1.62 0 0 1-2.202 0 1.418 1.418 0 0 1 0-2.084l6.765-6.4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconPaperclipSharp);
export default Memo;
